import { Vue, Component } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { v4 as uuidv4 } from "uuid";

const SiteMonitor = namespace("siteMonitor");

@Component
export default class AppliancePollingMixin extends Vue {
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	@SiteMonitor.Action private pollApplianceServerAndDeviceServerDetails: (source?: string) => Promise<void>;
	@SiteMonitor.Action private stopPollingApplianceServerAndDeviceServerDetails: (source?: string) => void;

	protected appliancePollingSourceId: string = "";

	// $route is only safely accessible once real Vue lifecycle hooks are running -
	// vue-class-component's field-initializer trick doesn't proxy underscore-prefixed
	// internals like _routerRoot, so $route throws if read from a class field initializer.
	created(): void {
		const routeName = this.$route?.name ?? "no-route";
		this.appliancePollingSourceId = `${routeName}:${this.$options.name}:${Date.now().toString(36)}:${uuidv4()}`;
	}

	protected get isAppliancePollingFeatureEnabled(): boolean {
		return !!this.getFeature(["Devices", "Appliances", "AppliancePolling"]);
	}

	protected async startAppliancePolling(): Promise<void> {
		if (!this.isAppliancePollingFeatureEnabled) {
			return;
		}

		await this.pollApplianceServerAndDeviceServerDetails(this.appliancePollingSourceId);
	}

	protected stopAppliancePolling(): void {
		this.stopPollingApplianceServerAndDeviceServerDetails(this.appliancePollingSourceId);
	}
}
